import React from "react";
import * as E from "./styles";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";


@inject("reportStore","reportFormStore")
@observer
class ReportTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentReportKey : null
    }

  }
  componentDidMount() {
    this.props.reportStore.getReports();
  }  

  onSelectReport = (reportKey) => {
    const {reportStore } = this.props;
    const { reports, report } = reportStore;
    let activeReport = reports.find(r=>r.type === reportKey);
    if (activeReport) {
      if(activeReport.type === report?.type){
        reportStore.setReport(null);
      }else{
        reportStore.setReport(activeReport);
      }
    }
  }

  render() {
    const { reportStore } = this.props;
    const { reports, report } = reportStore;

    return (
      <E.Container>
        <E.Title>{`Report List`}</E.Title>
        <E.List>
            <E.Container>
              <E.Row style={{flexWrap: 'wrap', gap: 16}}>
                {reports?.map((item, idx) => (
                  <E.Col key={`col-${idx}`}>
                    <E.ReportElement onClick={()=>this.onSelectReport(item.type)} className={report?.type === item.type ? 'active': ''}>
                      <E.ReportTitle>{ item.title }</E.ReportTitle>
                      <E.Description>{ item.description }</E.Description>
                      </E.ReportElement>
                  </E.Col>
                ))}
              </E.Row>
            </E.Container>
        </E.List>

      </E.Container>
    );
  }
}

export default withRouter(ReportTypes);
